module.exports = __webpack_public_path__ + "img/kurma-logo.f946248a.png";